import { render, staticRenderFns } from "./integrationEdit.vue?vue&type=template&id=683374fa"
import script from "./integrationEdit.vue?vue&type=script&lang=js"
export * from "./integrationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports